import React, { useContext } from 'react';
import { Badge, Button } from 'antd';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './AlertResultsFilters.module.less';
import { FiltersContext } from './FiltersContext';

export const FiltersButton: React.FC = () => {
  const { collapsed, filtersCount, resetForm, toggleCollapsed } = useContext(FiltersContext);

  const handleReset = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    resetForm();
  };

  return (
    <Button.Group className={clsx([styles.filtersButton, collapsed && styles.collapsed])}>
      <Badge count={filtersCount}>
        <Button type="primary" onClick={toggleCollapsed}>
          {collapsed ? (
            <FontAwesomeIcon icon={['fal', 'filter']} size={'lg'} />
          ) : (
            <>
              <FontAwesomeIcon icon={['far', 'chevron-right']} size={'lg'} />
              <span>Filters</span>
            </>
          )}
        </Button>
      </Badge>

      {filtersCount > 0 && (
        <Button type="primary" onClick={handleReset}>
          <FontAwesomeIcon icon={['fal', 'times']} />
        </Button>
      )}
    </Button.Group>
  );
};
